import { z } from 'zod'
import { LessonId } from './lessons/lessons'

export interface FeatureInfo {
    title: string
    shopItem?: 'ready' | 'beta' | 'alpha'
    lessonId?: LessonId
}

// TODO: create a Planda feature usefulness survey
export const ALL_UNLOCKABLE_FEATURES = {
    'week-list-page': {
        title: 'Week List Page',
        shopItem: 'ready', // not sure about this one
    } as FeatureInfo,
    subtasks: {
        title: 'Subtasks',
        shopItem: 'ready',
    } as FeatureInfo,
    'i.templateDB.task': {
        title: 'Scheduled Tasks and Task Templates',
        shopItem: 'ready',
    } as FeatureInfo,
    'rule-of-three': {
        title: 'Rule of Three',
        shopItem: 'ready',
    } as FeatureInfo,
    'snack-list': {
        title: 'Snack List',
        shopItem: 'ready',
    } as FeatureInfo,
    'daily-list': {
        title: 'Daily List',
        shopItem: 'beta',
    } as FeatureInfo,
    kanban: {
        title: 'Kanban Board',
        lessonId: 'kanban',
        shopItem: 'ready',
    } as FeatureInfo,
    // socials: {
    // TODO: add sending encouraging message to friends as a permanent task
    // also maybe add complete 5 tasks as a permanent task
    //     title: 'Planda Socials',
    // } as FeatureInfo,
    'syllabus-parser': {
        title: 'Syllabus Parser',
    },
    goals: {
        title: 'Goals',
    } as FeatureInfo,
    'i.task-difficulty': {
        title: 'Task Difficulty',
    },
    'planning-mode': {
        title: 'Planning Mode',
    },
    'i.task-estimated-time': {
        title: 'Task Estimated Time',
    },
    'capture-list': {
        title: 'Capture List',
    },
    'weekly-list': {
        title: 'Weekly planning',
    },
    chronotype: {
        title: 'Chronotype',
    },
    'power-hours': {
        title: 'Power Hours',
    },
    'timegrid-panel': {
        title: 'Timegrid Calendar Panel',
    },
    'daygrid-panel': {
        title: 'Daygrid Calendar Panel',
    },
    'animation-settings': {
        title: 'Animation Settings',
    },
    'dynamic-week-start': {
        title: 'Dynamic Week Start',
    },
    'quote-settings': {
        title: 'Quote Settings',
    },
    'beta-settings': {
        title: 'Beta Settings',
    },
    'student-grades': {
        title: 'Track your grades',
    },
    'priority-square': {
        title: 'Priority Table',
    },
    'summary-table': {
        title: 'Summary Table',
    },
    'multi-select-tasks': {
        title: 'Multi-Select Tasks',
    },
    'task-on-track-gauge': {
        title: 'Task On Track Gauge',
    },
    'i.location': {
        title: 'Event Location',
    },
    'work-blocks': {
        title: 'Work Blocks',
    },
    'i.restful': {
        title: 'Restful, re-energizing events + todos',
    },
    'activity-graphs': {
        title: 'Activity Graphs',
    },
    'past-current-future': {
        title: 'Past, Current, Future',
    },
    'brain-dump': {
        title: 'Brain Dump',
    },
    'habit-tracker': {
        title: 'Habit Tracker',
    },
    'completed-tasks-view': {
        title: 'Completed Tasks Overview',
    },
    'weather-panda': {
        title: 'Weather Pandas',
    }
    // 'task-next-actions': {
    //     title: 'Next Actions'
    // },
} as const

type Feature = keyof typeof ALL_UNLOCKABLE_FEATURES
export const FeatureEnum = z.enum(Object.keys(ALL_UNLOCKABLE_FEATURES) as [Feature, ...Feature[]])
export type FeatureEnum = z.infer<typeof FeatureEnum>

// These features have tutorial, but will never show up in "Current Lesson", since they don't teach you anything about productivity
const TOOL_FEATURES_BY_IMPORTANCE: Feature[] = [
    'syllabus-parser',
    'timegrid-panel',
    'multi-select-tasks',
    'quote-settings',
    'daygrid-panel',
    'animation-settings',
    'beta-settings',
    'dynamic-week-start',
]
